import * as React from 'react';

import { Grid } from '@mui/material';

import { INLINE_VIDEOS } from '../constants';
import { RevenueCardDetailsSection, InlineVideoSection } from './index';
import { useIntersectionObserver } from './utils';

function RevenueSection() {
  const { isIntersecting, ref } = useIntersectionObserver();

  return (
    <Grid
      container={true}
      justifyContent={'center'}
      className={'home-page__revenue-container max-container'}
    >
      <Grid item={true} xs={12} className="home-page__revenue-explore-games-container">
        <a
          href="https://games.skillz.com"
          target="_blank"
          rel="noopener noreferrer"
          className="home-page__revenue-explore-games-button"
        >
          Explore Skillz Games
        </a>
      </Grid>
      <Grid item={true} xs={10} md={5} lg={4} className="home-page__revenue-header-box max-screen">
        <div className={`fade-in-section ${isIntersecting ? 'is-visible' : ''}`} ref={ref}>
          <h1 data-qa="home-page__main-title">Fueling your revenue potential</h1>
          <p>
            Competition is the most player-centric monetization tool, as it puts the focus on your
            content not ads or in-app purchases. Skillz Developer Revenue Share Model will give you
            greater revenue transparency and higher earning potential.
          </p>
        </div>
      </Grid>

      <RevenueCardDetailsSection />
      <InlineVideoSection videoInfo={INLINE_VIDEOS.born} />
    </Grid>
  );
}

export { RevenueSection };
